import { render, staticRenderFns } from "./TopicHierarchy.vue?vue&type=template&id=8ce84486&"
import script from "./TopicHierarchy.vue?vue&type=script&lang=ts&"
export * from "./TopicHierarchy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports